<form class="form-container job-selection-dialog-content" [formGroup]="umapForm">
    <cds-form-group layout="horizontal" controlWidth="shrink">
        <div class="number-input-row">
            <label class="number-input-label">Number of neighbors</label>
            <input
                class="number-input-no-arrow"
                type="number"
                [min]="1"
                [formControlName]="NUMBER_OF_NEIGHBORS_FORM_KEY"
            />
        </div>
        <div class="number-input-row">
            <label class="number-input-label">Number of epochs</label>
            <input
                class="number-input-no-arrow"
                type="number"
                [min]="1"
                [formControlName]="NUMBER_OF_EPOCHS_FORM_KEY"
            />
        </div>
        <div class="number-input-row">
            <label class="number-input-label">Minimum distance</label>
            <input
                class="number-input-no-arrow"
                type="number"
                [min]="0"
                [formControlName]="MINIMUM_DISTANCE_FORM_KEY"
            />
        </div>
        <div class="number-input-row">
            <label class="number-input-label">Spread</label>
            <input
                class="number-input-no-arrow"
                type="number"
                [min]="0"
                [formControlName]="SPREAD_FORM_KEY"
            />
        </div>
        <cds-checkbox-group controlWidth="shrink">
            <label>Random initialization</label>
            <cds-checkbox controlWidth="shrink">
                <label></label>
                <input type="checkbox" [formControlName]="RANDOM_INITIALIZATION_FORM_KEY" />
            </cds-checkbox>
        </cds-checkbox-group>
        <cds-select controlWidth="shrink">
            <label>Distance metric</label>
            <select [formControlName]="DISTANCE_METRIC_FORM_KEY">
                <option *ngFor="let metric of UmapDistanceMetricValues">{{ metric }}</option>
            </select>
        </cds-select>
        <cds-select controlWidth="shrink">
            <label>Normalization</label>
            <select [formControlName]="NORMALIZATION_FORM_KEY">
                <option *ngFor="let normalization of ClusteringNormalizationValues">
                    {{ normalization }}
                </option>
            </select>
        </cds-select>
    </cds-form-group>
</form>
<div class="actions action-buttons">
    <cds-button size="sm" action="flat" (click)="cancel()">Cancel</cds-button>
    <cds-button size="sm" (click)="confirmParams()" [disabled]="!paramsValid">Next</cds-button>
</div>
